function inputCheck (value) {
  return /[^\d|.|,|\u3002]/.test(value)
}

export const onKeyPress = (e, m) =>
  inputCheck(e.key) || e.target.value.length >= m && e.preventDefault()

export const onInputChange = (e, fn, filed, places) => {
  let num = e.target.value
  if (inputCheck(num)) {
    return ''
  }
  if (/\u3002|,/.test(num)) {
    num = num.replace(/[\u3002|,]/g, '.')
  }
  if (/^0\d/.test(num)) {
    num = '0'
  } else if (/^\./.test(num)) {
    num = 0 + num.substring(0, places + 1)
  } else if (Number(num) >= 0) {
    if (num.indexOf('.') !== -1 && num.split('.')[1].length >= places) {
      num = num.replace(new RegExp(`^(\\d*\\.\\d{${places}})\\d*`), '$1')
    }
  }
  if (Number.isNaN(Number(num))) {
    return ''
  }
  fn(filed, num)
}

export const onBlur = e => !(/\d*\.?\d+$/.test(e.target.value)) && (e.target.value = '')

export const onKeyDown = (e, cb) => e.key === 'Enter' && cb()
